export const windowOpenBlank = (activationURL: string | null, UTMSourceURL: string | URL) => {
    window.open(
        activationURL ? activationURL : UTMSourceURL,
        "_blank",
        "noopener noreferrer"
    );
}